import type { FC } from 'react'

import { GraduationCap, Smartphone, Wallet, Wrench } from 'lucide-react'
import { Reveal } from '@/components/generals/reveal'
import { SectionHeading } from '@/components/landing/section-heading'
import { supportItems } from '@/constants/content'

const icons = {
    wallet: Wallet,
    wrench: Wrench,
    smartphone: Smartphone,
    graduation: GraduationCap
}

export const Support: FC = () => {
    return (
        <section id='support' aria-labelledby='support-title' className='relative z-10 scroll-mt-16 border-t border-white/[0.07] bg-surface py-24 sm:py-32'>
            <div className='mx-auto max-w-7xl px-5 sm:px-8'>
                <SectionHeading
                    id='support-title'
                    eyebrow="Service and finance"
                    title="More than a forklift."
                    body="Every FORQ comes with the people, software and financing to keep it working for years."
                />

                <div className='mt-14 grid gap-px overflow-hidden rounded-3xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4'>
                    {supportItems.map((item, index) => {
                        const Icon = icons[item.icon]

                        return (
                            <Reveal key={item.title} delay={index * 90} className='h-full bg-card'>
                                <div className='group flex h-full flex-col p-7 transition-colors hover:bg-white/[0.02] sm:p-8'>
                                    <span className='flex size-11 items-center justify-center rounded-xl bg-brand/10 text-brand transition-transform duration-500 group-hover:-translate-y-1'>
                                        <Icon className='size-5' />
                                    </span>
                                    <h3 className='mt-8 font-heading font-expanded text-lg font-bold text-white'>
                                        {item.title}
                                    </h3>
                                    <p className='mt-3 text-sm leading-relaxed text-white/60'>
                                        {item.body}
                                    </p>
                                </div>
                            </Reveal>
                        )
                    })}
                </div>
            </div>
        </section>
    )
}
